import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import {
    loadRun
} from '../../actions/runActions';
import { loadRunReceipts } from '../../actions/receiptActions';
import { subscribeToTruck } from '../../utils/truckHub';
import {Aux, BASE_URL, IsInRole, IsNullOrUndefined, ROLE_Driver} from "../../constants";
import DriverRunSummary from "./DriverRunSummary";
import DriverPickupView from "./DriverPickupView";
import {Link} from "react-router-dom";
import TankChecklistView from "./TankChecklistView";
import ScaleStatusView from "../Scales/ScaleStatusView";
import RunReceiptsList from "../Common/RunReceiptsList";

class RunPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        
        this.state = {
          pickupEditId: null,          
        };
        this.locationRefs = [];
        this.onEditChange = this.onEditChange.bind(this);
        this.getScrollLocationId = this.getScrollLocationId.bind(this);
    }

    componentDidMount() {
        if (this.props.runId) {
            this.props.dispatch(loadRunReceipts(this.props.runId));
        }
        // Ensure we're in this truck's hub group so receipt/PickupCompleted pushes arrive live even
        // if the driver hasn't checked in at base yet (which is what MainIndex keys subscription off).
        if (this.props.run && this.props.run.truckNumberPlate) {
            subscribeToTruck(this.props.run.truckNumberPlate);
        }
    }

    componentDidUpdate(prevProps) {
        const plate = this.props.run && this.props.run.truckNumberPlate;
        const prevPlate = prevProps.run && prevProps.run.truckNumberPlate;
        if (plate && plate !== prevPlate) {
            subscribeToTruck(plate);
        }
    }

    onEditChange(pickup, isEdit) {
        this.setState({pickupEditId: IsNullOrUndefined(pickup) || !isEdit ? null : pickup.id});
    }
    
    getScrollLocationId() {
        let {run} = this.props;
        if(IsNullOrUndefined(run) || IsNullOrUndefined(run.pickups)){
            return  null;
        }
        if (this.props.locationId > 0) {
            return this.props.locationId;
        }
        for (let i = 0; i < run.pickups.length; i++) {
            if (run.pickups[i].pickupStatusCode === 'PEN') {
                return run.pickups[i].locationID;
            }
        }
        return null;
    }
    
    render() {
        let {run, tankId, unfinishedRun, locationId, runId, weightScales, truckData} = this.props;
        let {pickupEditId} = this.state;

        let hasExistingRun = !IsNullOrUndefined(unfinishedRun);
        let scrollLocationId = this.getScrollLocationId();
        let pickups = run.pickups;
        if(IsInRole(this.props.account, ROLE_Driver)){
            pickups = _.filter(pickups, o => !o.smsNoResponse);
        }
        return IsNullOrUndefined(run) || IsNullOrUndefined(run.pickups) ? null : (<Aux>

            { hasExistingRun && <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-block">
                            <h5>
                                <span className="badge badge-danger">Run {unfinishedRun.id} is incomplete</span>
                            </h5>
                            <h4>{unfinishedRun.runDate}</h4>
                            <h4 className="card-title"><Link to={`${BASE_URL}/runs/driver/${unfinishedRun.id}`} className="nav-link">{unfinishedRun.regionsVisited} - {unfinishedRun.truckName}</Link></h4>
                            <h6>This run must be completed before another run can be started</h6>
                        </div>
                    </div>
                </div>
            </div>}

            <div className={"mb-1"}>
                <ScaleStatusView weightScales={weightScales} truckNumberPlate={run.truckNumberPlate} truckData={truckData} />
            </div>
            
            <DriverRunSummary run={run} account={this.props.account}  onRunRefresh={() => {
                this.props.dispatch(loadRun(runId)); 
            }}/>
            
            <TankChecklistView 
                runId={runId} 
                baseLocationIds={run.pickups.filter(x => x.isBase).map(x => x.locationID)} 
                onUpdate={() => this.props.dispatch(loadRun(runId))}
                showCollapsed={!run.hasDropOffTanks}
            />
                      
            {run.hasDropOffTanks ?
                (<div className={"row"}>
                    <div className={"col-12"}>
                        <h4>This run has tanks that require assignment, please assign before proceeding</h4>
                    </div>
                </div>) : 
                pickups.map((pickup) => {
                return (
                        <DriverPickupView
                            ref={elem => this.locationRefs[pickup.locationID] = elem}
                            key={pickup.id} 
                                run={run} 
                                pickup={pickup} 
                                tankId={tankId}
                                enableEdit={(IsNullOrUndefined(pickupEditId) || pickupEditId === pickup.id) && !hasExistingRun}
                                onEditChange={this.onEditChange}
                            scrollToThis={IsNullOrUndefined(scrollLocationId) ? false : pickup.locationID === scrollLocationId}
                            weightScales={weightScales}
                            account={this.props.account}
                        />);
            })}

            { run.id && <RunReceiptsList runId={run.id} /> }

        </Aux>);
    }
}

RunPage.propTypes = {
    runId: PropTypes.number.isRequired,
    run: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    weightScales: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps){

    let runId = parseInt(ownProps.routeParams.id);
    let locationId = parseInt(ownProps.routeParams.locationId);
    let tankId = parseInt(ownProps.routeParams.tankId);
    let run = null;
    let unfinishedRun = null;

    //look at state.driverRuns and state.searchRuns, attempt to get the run from there

    if(runId && state.driverRuns && state.driverRuns.items.length > 0){
        let filtered = state.driverRuns.items.filter(x => x.id === runId);

        if(filtered.length === 1){
            run = filtered[0];
            //are any runs checked in, and if so is it this one
            let unfinished = state.driverRuns.items.filter(x => !x.isComplete && x.id !== runId && x.isCurrentUserDriver && (x.isBaseCheckedIn || x.runOrder < run.runOrder));
            unfinishedRun = unfinished.length > 0 ? unfinished[0] : null;

            if(unfinishedRun && run && run.isBaseCheckedIn){
                unfinishedRun = null;
            }
        }
    }
    if(state.run && state.run.id === runId){
        run = state.run;
    }
    if(!run){
        run = {};
    }

    return {
        run: run,
        unfinishedRun: unfinishedRun,
        runId: runId,
        account: state.account,
        locationId,
        tankId,
        weightScales: {
            connected: state.truckData.weight.connected,
            currentWeight: state.truckData.weight.currentWeight,
            currentRawWeight: state.truckData.weight.currentRawWeight,
            truckNumberPlate: state.truckData.truckNumberPlate,
            errorReason: state.truckData.errorReason,
        },
        truckData: state.truckData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RunPage));
